export default __webpack_public_path__ + "static/media/downIcon_B.da7a9b24.svg";